import React, { Component } from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import './informacion.css';
import Alert from 'react-s-alert';
import store from '../../store';
import buscarNodo from './buscarNodo';
import copyright from '../../img/copyright-gray.png';
import * as XLSX from 'xlsx'
import { sendLog } from '../../util'
import moment from 'moment';

const database = firebase.database();
const buscarCliente = buscarNodo('Clientes');

class Informacion extends Component {
	constructor(props) {
		super(props);
		this.state = {
			nombre: '',
			direccion: '',
			logo: '',
			mision: '',
			vision: '',
			uploadValue: 0,
			files: null,
			template: true,
			actual: 0

		}
		this.informacionRef = database.ref().child('informacion_empresa');
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleUpload = this.handleUpload.bind(this);
		this.handleClickAlerta = this.handleClickAlerta.bind(this);
		this.ocultarMenu = this.ocultarMenu.bind(this);
		this.modificarPasajeros();
		// this.nuevoUsuario();
		// this.verificarVelocidades();
		// this.nuevoConductor();

		this.AlertaContenido = ({
			id,
			classNames,
			styles,
			message,
			customFields,
			handleClose,
		}) => {
			const handleConfirm = () => {

				this.handleSubmit();
				Alert.close(id);
				this.setState({
					template: false
				})
			}
			return (
				<div className={classNames} id={id} style={styles}>
					<div className='s-alert-box-inner'>
						{message}
					</div>
					<br />
					<br />
					<button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
					<button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
					<span className='s-alert-close' onClick={handleClose}></span>
				</div>
			);
		}
	}

	nuevoUsuario = () => {
		const uid = 'Rac34Dn4n2MolBUbD3byvCRXTff1';
		const obj = {
			correo: "amartinez@i-strategies.tech",
			estado: "Activo",
			nombre: "Abdiel",
			perfil: "Administrador",
		}

		firebase.database().ref().child('Usuarios_Acacya').update({ [uid]: obj });
	}

	modificarPasajeros = async ()=>{
		const fechaInicial = moment(new Date(2019,9,1));
		for (let i = 0; i < 7; i++) {
			const fechaStr = new Date(fechaInicial.year(), fechaInicial.month(), fechaInicial.date()).toString();
			console.log('fechaStr :', fechaStr);
			const snap = await firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(fechaStr).once('value');
			const data = snap.val();
	
			const prograDias=[];
			for (const key in data) {
				if(data[key].Pasajeros){
					for (const i in data[key].Pasajeros) {
						const resCliente = await buscarCliente(data[key].Pasajeros[i].codigo);
							data[key].Pasajeros[i].numero_empleado = resCliente && resCliente.numero_empleado || 0 ;
							data[key].Pasajeros[i].centroCosto     = resCliente && resCliente.centro || '';
							data[key].Pasajeros[i].areaU           = resCliente && resCliente.areaDesc || '';
							data[key].Pasajeros[i].coordenadas     = resCliente && resCliente.coordenadas && resCliente.coordenadas.coordenadas || false;
							data[key].Pasajeros[i].escalafon       = resCliente && resCliente.escalafon || '' ;
					}
					firebase.database().ref().child('ProgramacionDia').child(key).update({Pasajeros:data[key].Pasajeros});
					prograDias.push(key);
				}
			}
			console.log('prograDias :', prograDias);

			fechaInicial.add(1,'d');
		}
	}

	nuevoConductor = async () => {
		const uid = 'HehlrluKJXXijGaZ03CeKHisNei2';
		const data = {
			correo: "amartinez@i-strategies.tech",
			direccion: "Avianca",
			dui: "01234567-8",
			edad: "21",
			espera: true,
			estado: "activo",
			foto: "https://firebasestorage.googleapis.com/v0/b/tak...",
			latitud: 13.701950380252162,
			licencia: "0514-130875-102-4",
			longitud: -89.20134488794466,
			nombre: "Abdiel Antonio Martinez",
			socio: "7vxquppr3dPUwcSu8CFgNpIY3ag2",
			telefono: "78907890",
			tipo_vehiculo: "Coaster",
			true: false,
			uid,
			vehiculo: "-LTDiKcvTCgbpZw6FXyF",
			velocidad: 0,
			viajeAsignado: false
		};

		firebase.database().ref().child('Empleados').update({ [uid]: data });
	}

	verificarVelocidades = async () => {
		const fecha = new Date(2019, 6, 5);
		const strFecha = fecha.toString();

		const snap = await firebase.database().ref().child('ProgramacionDia').orderByChild('fecha').equalTo(strFecha).once('value');
		const data = snap.val();
		const records = [];

		for (const key in data) {
			if (data[key].estado == 'Finalizado')
				records.push(data[key]);
		}

		// for (const item of records) {

		// 	const result = await this.calcularVMax(item);
		// 	if(result.vProm && result.vMax){
		// 		await firebase.database().ref().child('ProgramacionDia').child(item).update({
		// 			vProm: result.vProm,
		// 			vMax : result.vMax
		// 		})
		// 	}
		// }
	}

	calcularVMax = async (id) => {
		try {
			const snap = await firebase.database().ref('DatosViajes/' + id).once('value');
			const dataProg = snap.val();
			const obj = {};

			if (dataProg && dataProg.velocidad && dataProg.velocidad.length) {
				let numeros = dataProg.velocidad.map(val => Number(val));
				numeros = numeros.filter(val => !isNaN(val));
				const max = (Math.max(...numeros)).toFixed(2);

				const sumatoria = numeros
					.reduce((acumulador, siguienteValor) => {
						return acumulador + siguienteValor;
					}, 0);

				const promedio = (sumatoria == 0) ? 0 :
					(sumatoria / dataProg.velocidad.length).toFixed(2);

				obj.vProm = promedio;
				obj.vMax = max;
			}

			return obj;
		} catch (error) {
			console.log('error :', error);
		}
	}

	handleClickAlerta(event) {
		this.setState({
			template: true
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
			position: 'top-right',
			timeout: 'none',
			customFields: {
				customerName: customerName
			}
		});

		event.preventDefault();
	}

	componentWillUnmount = () => {
		this.informacionRef.off();
	}

	componentDidMount() {
		// this.getData();
		this.informacionRef.off();
		this.informacionRef.on('value', this.gotData, this.errData);
	}

	scriptDuiSinGuion = async () => {
		const snapClientes = await firebase.database().ref('/Clientes').once('value');
		const clientes = snapClientes.val();
		for (const key in clientes) {
			if (clientes[key].dui) {
				const pattern = /-/;
				if (pattern.test(clientes[key].dui)) {
					const newDui = clientes[key].dui.split('-').join('');
					firebase.database().ref().child('Clientes').child(key).update({ dui: newDui })
						.then(() => console.log(''))
						.catch(err => console.log('err :', err));
				}
			}
		}
	}

	capturaDatos = (event) => {
		try {
			let datos = [];
			var done = false;
			var file = event.target.files[0];
			const reader = new FileReader();

			reader.onloadend = (event) => {
				const bstr = event.target.result;
				const wb = XLSX.read(bstr, { type: 'binary' });

				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];

				const data = XLSX.utils.sheet_to_json(ws, { header: "A" });

				firebase.database().ref('Clientes').once('value').then(snap => {
					let clientes = [];
					snap.forEach(element => {
						let data = element.val();
						data.key = element.key;
						clientes.push(data)
					});
					firebase.database().ref('CentroCosto').once('value').then(snapC => {
						let centros = [];
						snapC.forEach(element => {
							let data = element.val();
							data.key = element.key;
							centros.push(data)
						});
						let clientesM = [];
						data.forEach((element, index) => {
							if (index !== 0) {
								let centroN = centros.find(c => c.codigo === element.C)
								let clientesF = clientes.find(cl => cl.numero_empleado === element.A)
								if (clientesF === undefined || centroN === undefined) {
									// console.log(element.A)
								} else {
									clientesF.centro = centroN.key;
									clientesM.push(clientesF)
								}
							}
						});
						clientesM.forEach(element => {
							firebase.database().ref().child('Clientes/' + element.key).update({
								centro: element.centro
							})
						});
					
					})
				})
			}
			reader.readAsBinaryString(file);
		}
		catch (error) {
			console.log(error.message);
		}
	}

	gotData = (data) => {
		const informacionData = data.val();
		this.nombreEmpresa.value = informacionData['informacion'].nombre;
		this.direccionEmpresa.value = informacionData['informacion'].direccion;
		this.visionEmpresa.value = informacionData['informacion'].vision;
		this.misionEmpresa.value = informacionData['informacion'].mision;
		this.setState({
			logo: informacionData['informacion'].logo

		});
	}
	errData = (err) => {
		console.log(err);
	}


	handleSubmit() {

		sendLog({ tipo: 'informacion_empresa_propietaria_editado' });

		let nombre = this.nombreEmpresa.value;
		let direccion = this.direccionEmpresa.value;
		let vision = this.visionEmpresa.value;
		let mision = this.misionEmpresa.value;


		let archivo = this.state.files;

		if (this.state.files === null) {

			this.informacionRef.child('informacion').update({

				nombre: nombre,
				direccion: direccion,
				mision: mision,
				vision: vision,

			});

			Alert.success('Datos guardados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout: 2000
			});

		}
		else {


			const storageRef = firebase.storage().ref(`Empleados/${archivo.name}`);

			const task = storageRef.put(archivo);

			task.on('state_changed', snapshot => {


				this.setState({
					uploadValue: 50,
				})

			}, error => {
				console.log(error.message);
			},
				async () => {
					const url = await task.snapshot.ref.getDownloadURL();

					this.informacionRef.child('informacion').update({

						nombre: nombre,
						direccion: direccion,
						mision: mision,
						vision: vision,
						logo: url

					});

					this.setState({
						uploadValue: 100
					});

					Alert.success('Datos guardados correctamente', {
						effect: 'genie',
						position: 'bottom-right',
						timeout: 2000
					});

				});

		}

	}


	handleUpload(e, filee) {

		var file = e.target.files[0],
			pattern = /image-*/,
			reader = new FileReader();

		if (file === undefined) {

			this.setState({
				logo: null,
				files: null
			});

		}
		else {

			if (!file.type.match(pattern)) {

				alert('Por favor ingresa una imagen con formato valido');
				return;
			}



			reader.onload = (e) => {
				this.setState({
					logo: reader.result,
					files: file
				});
			}

			reader.readAsDataURL(file);

		}




	}


	ocultarMenu() {


		store.dispatch({

			type: 'STATE_MOSTRAR',
			mostrar: 'noMostrar'
		})
	}

	getData = () => {
		firebase.database().ref('DatosViajes').once('value').then(snap => {
			let datosViajes = [];
			snap.forEach(element => {
				let datos = element.val();
				datos.key = element.key;
				datosViajes.push(datos)
			});
			this.validar(datosViajes);
		})
	}


	validar = (datosViajes) => {
		firebase.database().ref('ProgramacionDia').once('value').then(snap => {
			let validos = []
			snap.forEach(element => {
				let datos = element.val();
				datos.key = element.key;
				if (datos.estado === 'Finalizado') {
					let datos = datosViajes.find(snap => snap.key === element.key);
					if (datos !== undefined) {
						if (datos.velocidad !== undefined && Array.isArray(datos.velocidad)) {
							var max = Math.max.apply(null, datos.velocidad);
							var sumatoria = datos.velocidad.reduce((acumulador, siguienteValor) => {
								return acumulador + siguienteValor;
							}, 0);
							var promedio = (sumatoria / datos.velocidad.length).toFixed(2);

							if (promedio >= 0 && max >= 0) {
								datos = { key: datos.key, vProm: (promedio * 3.6), vMax: (max * 3.6) }
								validos.push(datos)
							}
						}
					}
				}
			});
			setTimeout(() => {
				let { actual } = this.state;
				for (let index = actual; index < (actual + 3093); index++) {
					let datos = validos[index];
					firebase.database().ref().child('ProgramacionDia/' + datos.key).update({
						vProm: datos.vProm,
						vMax: datos.vMax
					}).then(snap => {
						
					}).catch(error => {
						
					})
				}
			}, 2500);
		})
	}

	render() {

		return (

			// <div className="col-sm">
			// 	<label className="custom-file-label" for="excel">Seleccionar fila</label>
			// 	<input type="file" className="custom-file-input" id="excel" onChange={this.capturaDatos}/>
			// </div>

			<div className="Informacion container" onClick={this.ocultarMenu}>


				{this.state.template ? <Alert timeout='none' contentTemplate={this.AlertaContenido.bind(this)} /> : <Alert stack={{ limit: 3 }} html={true} />}

				<div className="row cn">
					<div className="col-md-12">
						<form method="POST" action="" onSubmit={this.handleClickAlerta}>

							<div className="form-group">
								<label htmlFor="nombreEmpresa">Nombre de la empresa:</label>
								<input type="text" name="nombreEmpresa" className="form-control"
									placeholder="Nombre Empresa" ref={input => { this.nombreEmpresa = input; }}
									required autoComplete="off"

								/>
							</div>

							<div className="form-group">
								<label htmlFor="direcccionEmpresa">Dirección:</label>
								<input type="text" name="direcccionEmpresa" className="form-control"
									placeholder="Dirección Empresa"
									ref={input => { this.direccionEmpresa = input; }}
									required autoComplete="off"
								/>
							</div>

							<div className="form-group">
								<label htmlFor="foto">Logo de la empresa</label>
								<br />
								<progress value={this.state.uploadValue} max="100"></progress>
								<input type="file" className="form-control" onChange={this.handleUpload} />
								<img src={this.state.logo} alt="Logo empresa" className="foto" width="240px"

								/>
							</div>


							<div className="form-group">
								<label htmlFor="mision">Mision:</label>
								<textarea className="form-control" placeholder="Misión..."
									ref={input => { this.misionEmpresa = input; }}
									required autoComplete="off" rows="6"
								></textarea>

							</div>

							<div className="form-group">
								<label htmlFor="vision">Vision:</label>
								<textarea className="form-control" placeholder="Visión..."
									ref={input => { this.visionEmpresa = input; }}
									required autoComplete="off" rows="6"
								></textarea>
							</div>

							<div className="form-group">
								<button type="submit" className="btn btn-success">Modificar</button>
							</div>

						</form>
					</div>
				</div>
				<footer class="footer-pg mt-auto py-3" style={{ width: '100%' }}>
					<div class="container">
						<div class="row">
							<div className="col-md-4 col-sm-4">
							</div>
							<div class="col-sm">
								<img src={copyright} />
							</div>
						</div>
					</div>
				</footer>
			</div>



		);

	}
}

export default Informacion;


// WEBPACK FOOTER //
// ./src/Components/Informacion/Informacion.jsx